export default function Section$bubble () {
	this.parentFragment.bubble();
}
